
import { IChartOptions, IChartResult } from './chartSteps';

import {
	axisesAndLegends,
	IAxisesAndLegendsResult,
	tryApplyCustomColors,
	tryTranslateCaption
} from './chartSteps';
import { ApexOptions } from 'apexcharts';
import { ResultSet } from '@cubejs-client/core';
import { cloneDeep, merge, isNil } from 'lodash';

export default function barChart(resultSet: ResultSet, options: IChartOptions, isGroupedByWeek: boolean, preloadedAxisNames: string[] | null = null): IChartResult {
	// IChartProps - IChartOptions
	let r = axisesAndLegends(resultSet, cloneDeep(options), isGroupedByWeek, preloadedAxisNames);
	r = tryApplyCustomColors(r);
	// r = tryPercentage(r);

	return toChartResult(r, options);
	// r = tryApplyCustomColors(r);
}

function toChartResult(result: IAxisesAndLegendsResult, options: IChartOptions): IChartResult {
	let stacked = false;
	let isPerentage = false;
	let isHorizontal = false;
	if (!isNil(result) && !isNil(result.input) && !isNil(result.input.options)
		&& !isNil(result.input.options.config)) {
		if (Array.isArray(result.input.options.config)) {
			stacked = !isNil(result.input.options.config[0].isStacked) && result.input.options.config[0].isStacked;
			isPerentage = !isNil(result.input.options.config[0].isPercentage) && result.input.options.config[0].isPercentage;
			isHorizontal = !isNil(result.input.options.config[0].isHorizontal) && result.input.options.config[0].isHorizontal;
		} else {
			stacked = !isNil(result.input.options.config.isStacked) && result.input.options.config.isStacked;
			isPerentage = !isNil(result.input.options.config.isPercentage) && result.input.options.config.isPercentage;
			isHorizontal = !isNil(result.input.options.config.isHorizontal) && result.input.options.config.isHorizontal;
		}
	}

	const defaultOptions: ApexOptions = {
		chart: {
			type: 'bar',
			stacked,
			stackType: stacked && isPerentage ? '100%' : void 0
		},
		dataLabels: {
			formatter: (val: any/*, opts: any*/) => {
				if (stacked && isPerentage)
					return `${val.toFixed(1)}%`;
				return val;
			}
		},
		legend: {
			formatter: seriesName => tryTranslateCaption(seriesName, options.translate)
		},
		xaxis: {
			labels: {
				formatter: value => tryTranslateCaption(value, options.translate)
			}
		},
		yaxis: {
			labels: {
				formatter: value => tryTranslateCaption(value, options.translate)
			}
		},
		plotOptions: {
			bar: {
				horizontal: isHorizontal
			}
		},
		tooltip: {
			y: {
				title: {
					formatter: val => tryTranslateCaption(val, options.translate)
				}
			}
		}
	};
	return {
		options: merge({}, result.output.chartResult.options, defaultOptions),
		series: result.output.pivots.series
	};
}
